<template>
  <v-container fluid>
    <vivaWantingListByadmin />
    <!-- <vivaWantingListByCenter /> -->
  </v-container>
</template>

<script>
import vivaWantingListByadmin from "@/components/practicalVivaExam/vivaWantingList/vivaWantingListByadmin.vue";
// import vivaWantingListByCenter from "@/components/practicalVivaExam/vivaWantingList/vivaWantingListByCenter.vue";
export default {
  components: {
    vivaWantingListByadmin,
    // vivaWantingListByCenter
  },
  data() {
    return {};
  },
  created() {},
  computed: {},
  methods: {},
  watch: {}
};
</script>
<style scoped></style>
